import type { WxUrlData } from "@/api/message/common/MessageParser";
import { redirectToMiniProgram } from "@/utils/wxMiniProgram";
import { cn } from "@/lib/utils";

interface WxUrlButtonProps {
  wxUrl: WxUrlData;
  className?: string;
}

export function WxUrlButton({ wxUrl, className }: WxUrlButtonProps) {
  return (
    <button
      type="button"
      onClick={() => redirectToMiniProgram(wxUrl)}
      className={cn(
        "not-prose inline align-baseline",
        "px-1.5 rounded-full border-0 cursor-pointer",
        "text-[13px] font-medium text-[#007aff] leading-[20px]",
        "bg-[#f0f7ff] hover:bg-[#e3f0ff]",
        "active:scale-[0.98] transition-colors duration-150",
        className,
      )}
    >
      {wxUrl.name}
    </button>
  );
}
